import { Component, Injector, Optional, Input } from '@angular/core';

import { AlertService } from './alert.service';
import { Alert } from './alert';
import { PagedCollectionComponent, ColumnDefinition, Filter, createColumnDefinitions, SearchableType } from '@mango/core';
import { AlertType } from './alert-type';


@Component({
    selector: 'dla-app-alert-collection',
    templateUrl: './alert-collection.component.html'/*,
    styleUrls: ['./alert-collection.component.css'] */
})
export class AlertCollectionComponent  extends PagedCollectionComponent<Alert> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<Alert>([
        { colDef: 'title', prop: x => x.title, searchable: SearchableType.String },
        { colDef: 'message', prop: x => x.message, searchable: SearchableType.String },
        { colDef: 'date', prop: x => x.date, searchable: SearchableType.Date },
        { colDef: 'expiringDate', prop: x => x.expiringDate, searchable: SearchableType.Date },
        { colDef: 'type', prop: x => x.type, searchable: SearchableType.String }
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: AlertService, @Optional() protected filter: Filter<Alert>, injector: Injector) {
        super('/alerts', injector, Alert);

        if(!this.filter) {
            this.filter = new Filter<Alert>();
        }
        this.filter.onGetChipLabel(x => x.title, () => 'Titel');
        this.filter.onGetChipLabel(x => x.message, () => 'Bericht');
        this.filter.onGetChipLabel(x => x.date, () => 'Datum bericht');
        this.filter.onGetChipLabel(x => x.expiringDate, () => 'Einde bericht');
        this.filter.onGetChipLabel(x => x.type, () => 'Type');
    }

    getType(value) {

		switch (Number(value)) {
			case AlertType.Notification:
				return "Bericht";
			default:
				return "";
		}
	}
}